import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PropTypes from "prop-types";
import React from "react";
import { languages } from "../../constants/languages";

const styles = (theme) => ({
  button: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  iconButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
});

const psdAdmins = [
  "qwVXeKNiBzMz3RyUJSAJFLrkFnH2", // Abel
  "sOXBd83e27e3DOIRNaLE6f5Oesc2", // PSD (info)
];

const sportaAdmins = [
  "c9cdoS2iGcb3sJ1MFVDXIjzzUNs2", // Bert
  "qwVXeKNiBzMz3RyUJSAJFLrkFnH2", // Abel
];

const rvAdmins = [
  "NKuutwfS9xg1DAKAkb86tIubqyJ2", // Michel
  "yuZSGcZhb5bjfzMAcZumEcnJ9j63", // Mathias
  "qwVXeKNiBzMz3RyUJSAJFLrkFnH2", // Abel
];

const arenalAdmins = [
  "Os3Bv6BAi8S3esABDGabzBCmvAI3", // Glenn
  "PC2wBQrN49a1EHjhUOFnJcIK4iv2", // Lotte (Arenal Mechelen)
  "qwVXeKNiBzMz3RyUJSAJFLrkFnH2", // Abel
];

const AccountMenu = (props) => (
  <div>
    <Button
      className={props.classes.button}
      aria-owns={props.open ? "menu-appbar" : null}
      aria-haspopup="true"
      onClick={props.handleMenu}
      color="inherit"
    >
      <AccountCircle style={{ height: 25, marginRight: 5 }} />
      <span className={props.classes.buttonText}>
        {languages.header.account}
      </span>
    </Button>
    <IconButton
      className={props.classes.iconButton}
      aria-owns={props.open ? "menu-appbar" : null}
      aria-haspopup="true"
      onClick={props.handleMenu}
      color="inherit"
    >
      <AccountCircle style={{ height: 25, marginRight: 5 }} />
    </IconButton>
    <Menu
      id="menu-appbar"
      anchorEl={props.anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={props.open}
      onClose={props.handleClose}
      style={{ zIndex: 1302 }}
    >
      <MenuItem disabled>{props.user.email}</MenuItem>
      <MenuItem onClick={props.handleProfileClick}>
        {languages.header.settings}
      </MenuItem>
      <MenuItem
        onClick={props.handleBillingClick}
        disabled={!props.billingURL}
      >
        {languages.header.manageBilling}
      </MenuItem>
      {psdAdmins.indexOf((props.user || {}).uid) !== -1 && (
        <MenuItem onClick={props.handlePsdAdminClick}>PSD Admin</MenuItem>
      )}
      {sportaAdmins.indexOf((props.user || {}).uid) !== -1 && (
        <MenuItem onClick={props.handleSportaAdminClick}>Sporta Admin</MenuItem>
      )}
      {rvAdmins.indexOf((props.user || {}).uid) !== -1 && (
        <MenuItem onClick={props.handleRVClick}>Belgium Rugby</MenuItem>
      )}
      {arenalAdmins.indexOf((props.user || {}).uid) !== -1 && (
        <MenuItem onClick={props.handleArenalAdminClick}>Arenal Admin</MenuItem>
      )}
      <MenuItem onClick={props.handleSignOut}>
        {languages.header.signOut}
      </MenuItem>
    </Menu>
  </div>
);

AccountMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountMenu);
